import React, { useEffect, useState } from "react";
import axios from "axios";
import { VrViewer } from "./trace/VrViewer";
import { ExternalLink, Globe, Loader2, Orbit, Play } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (u && u.startsWith("/") ? `${BACKEND}${u}` : u);

/* 业主门户内嵌 360 全景：直接在卡片内拖动 / 陀螺仪环视，多张全景切换；保留「新窗口打开」分享页 */
export const OwnerVrEmbed = ({ shareUrl, zh }) => {
  const T = (a, b) => (zh ? a : b);
  const token = (shareUrl || "").split("/vr/")[1]?.split(/[?#]/)[0];
  const [items, setItems] = useState(null);
  const [cur, setCur] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!token) return;
    axios.get(`${BACKEND}/api/public/vr/${token}`).then(({ data }) => { setItems(data.items || []); setCur((data.items || [])[0] || null); })
      .catch(() => setErr(T("全景暂时无法加载，请点「新窗口打开」", "Panorama unavailable — use “Open”")));
  }, [token]); // eslint-disable-line
  if (!token) return null;
  return (
    <div className="mt-3" data-testid="owner-vr-embed">
      <div className="flex items-center justify-between gap-2 mb-1.5">
        <p className="text-xs font-semibold text-slate-700 inline-flex items-center gap-1"><Orbit className="h-3.5 w-3.5 text-cyan-600" />{T("360° 现场全景", "360° Site Panorama")}{items && <span className="text-slate-400 font-normal">· {items.length}</span>}</p>
        <a href={shareUrl} target="_blank" rel="noreferrer" data-testid="owner-site-survey-vr" className="inline-flex items-center gap-1 text-[11px] text-cyan-700 hover:underline"><ExternalLink className="h-3 w-3" />{T("新窗口打开", "Open in new tab")}</a>
      </div>
      {!items && !err && <p className="text-xs text-slate-400 inline-flex items-center gap-1"><Loader2 className="h-3.5 w-3.5 animate-spin" />{T("加载全景…", "Loading…")}</p>}
      {err && <p className="text-xs text-amber-700" data-testid="owner-vr-error">{err}</p>}
      {cur && <VrViewer inline item={cur} src={abs(cur.url)} zh={zh} />}
      {items && items.length > 1 && (
        <div className="flex gap-1.5 overflow-x-auto mt-1.5 pb-1" data-testid="owner-vr-thumbs">
          {items.map((it) => (
            <button key={it.id} type="button" onClick={() => setCur(it)} data-testid={`owner-vr-thumb-${it.id}`} aria-pressed={cur?.id === it.id}
              className={`shrink-0 w-24 rounded-lg overflow-hidden border-2 ${cur?.id === it.id ? "border-cyan-500" : "border-transparent"}`}>
              <div className="aspect-[2/1] bg-slate-900 flex items-center justify-center">
                {it.kind === "photo" ? <img src={abs(it.url)} alt="" className="h-full w-full object-cover" loading="lazy" /> : it.kind === "video" ? <Play className="h-4 w-4 text-white/80" /> : <Globe className="h-4 w-4 text-white/80" />}
              </div>
              <p className="text-[10px] text-slate-600 truncate px-1 py-0.5 text-left">{it.title || it.filename || it.url}</p>
            </button>
          ))}
        </div>
      )}
      {cur && <p className="text-[10px] text-slate-400 mt-1">{T("拖动或双指缩放查看；手机点底栏「陀螺仪」转动手机环视现场。红点为项目经理标注的风险点。", "Drag / pinch to look around; on mobile tap the gyroscope icon. Red dots are PM risk markers.")}</p>}
    </div>
  );
};
